// antdTokens.ts
import { theme } from 'antd';

const { getDesignToken, defaultAlgorithm, darkAlgorithm } = theme;

type ThemeMode = 'light' | 'dark';

export const getAntdTokens = (mode: ThemeMode = 'light') => {
    const algorithm = mode === 'dark' ? darkAlgorithm : defaultAlgorithm;

    const tokens = getDesignToken({ algorithm });

    return {
        colorBorder: tokens.colorBorder,
        colorBorderSecondary: tokens.colorBorderSecondary,
        colorBgContainer: tokens.colorBgContainer,
        colorText: tokens.colorText,
        colorTextSecondary: tokens.colorTextSecondary,
        colorPrimary: tokens.colorPrimary,
        colorBgElevated: tokens.colorBgElevated,
        colorPrimaryHover: tokens.colorPrimaryHover,
        borderRadius: tokens.borderRadius,
        borderRadiusXS: tokens.borderRadiusXS,
        borderRadiusSM: tokens.borderRadiusSM,
        borderRadiusLG: tokens.borderRadiusLG,
        borderRadiusOuter: tokens.borderRadiusOuter,
    };
};
